export const sampleCart = {
    id: 204984,
    status: 1,
    createdDate: "2025-03-09T11:38:21.000Z",
    applicationSourceId: 3,
    operatorEmployeeId: 1,
    tableTag: null,
    customer: null,
    posDeviceId: 141,
    merchant: {
        id: 69,
        name: "Buy N Large",
        businessName: "Buy N Large",
        address: "4 South Main Street Cork",
        vatNumber: "IE 6598535I",
        merchantLink: "y8yvzaiam6",
        imageURL: "https://upcoimages.s3.eu-west-1.amazonaws.com/images/product-image/1756896174574%20-%20logo-buy-n-large-1-4x.png",
        brand: {
            name: "Buy N Large",
            photoURL:
                "https://upcoimages.s3.eu-west-1.amazonaws.com/images/product-image/1756896174574%20-%20logo-buy-n-large-1-4x.png",
        },
        currency: {
            symbol: "$",
        },
    },
    cartProducts: [
        {
            id: 1312453,
            name: "Women's High-Rise Skinny Jeans",
            quantity: 1,
            subtotal: 19.99,
            basePrice: 19.99,
            currencyCode: "EUR",
            printName: "Women's High-Rise Skinny Jeans",
        },
        {
            id: 1312453,
            name: "Kid's Hoddie (Boys/Girls) @14.99 ea",
            quantity: 2,
            subtotal: 14.99,
            basePrice: 14.99,
            currencyCode: "EUR",
            printName: "Kid's Hoddie (Boys/Girls) @14.99 ea",
        },
        {
            id: 1312453,
            name: "Slip-On Sneakers (Men/Women) @24.99 ea",
            quantity: 2,
            subtotal: 24.99,
            basePrice: 24.99,
            currencyCode: "EUR",
            printName: "Slip-On Sneakers (Men/Women) @24.99 ea",
        },
        {
            id: 1312453,
            name: "Baseball Cap",
            quantity: 1,
            subtotal: 7.98,
            basePrice: 7.98,
            currencyCode: "EUR",
            printName: "Baseball Cap",
        },
    ],
    applicationSource: {
        name: "POS",
    },
    saleUnitCarts: [
        {
            id: 204922,
            totalAmount: 117.93,
            paidAmount: 0,
            processingFeeAmount: null,
            status: 2,
            cartId: 204984,
            serviceChargeId: 46,
            managerEmployeeId: null,
            isPrintCheckPrinted: true,
            merchantSaleUnit: {
                id: 403,
                noPersons: 4,
                minNoPersons: 1,
                allowCombinations: false,
                allowBookings: false,
                allowOrderAtTable: false,
                allowPOSTableService: true,
                isFood: null,
                isWaste: null,
                description: null,
                identifier: "38",
                uniqueId: "994b1b53-1fc4-4c4d-b03f-dff53fca9903",
                addableNoPersons: 0,
                position: null,
                saleRoomId: 45,
                sequence: 403,
                saleUnitTypeId: 2,
            },
        },
    ],
    cartTotal: 40.25,
};
